import React from 'react'
import Pinitimage from "./pinit.png"

export default function Pinit() {
  return (
    <img className ="w-64 m-auto rounded-lg hover:w-96 hover:ease-in duration-300" src={Pinitimage}></img>
  )
}
